'use strict';

export default class AddController {

    /*@ngInject*/
    constructor($http, $state, Upload, toaster) {
        this.$http = $http;
        this.$state = $state;
        this.Upload = Upload;
        this.toaster = toaster;
        this.newFirmware = {
            betaGroups: []
        };
    }

    $onInit() {
        this.getBetaGroups();
    }

    save() {
        if (this.newFirmware.changeListHtml && !this.isChangeListHtmlUrl(this.newFirmware.changeListHtml)) {
            let text = this.newFirmware.changeListHtml.replace(/<br\s*\/?>/gi, '\n').replace(/<\/p>/gi, '\n').replace(/<[^>]+>/g, '');
            this.newFirmware.changeList = text.split('\n').filter(line => line.trim().length > 0);
        }
        if (!this.checkData()) {
            return;
        }
        this.$http.post(`/api/firmware`, this.newFirmware).then(res => {
            this.$state.go('^');
        });
    }

    getBetaGroups() {
        this.$http.get('/api/betaGroups').then(res => {
            this.betaGroups = res.data;
        });
    }

    uploadChangeListHtml(file) {
        if (!file) {
            return;
        }
        this.toaster.pop({
            type: 'wait',
            title: '正在上传HTML，请稍等...',
            body: file.name,
            timeout: 3000 * 1000
        });

        file.upload = this.Upload.upload({
            url: '/api/firmware/uploadChangeListHtml',
            file: file,
            data: {
                downloadUrlList: this.newFirmware.downloadUrlList
            },
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });

        file.upload.progress((evt) => {
            file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });

        file.upload.success((data, status, headers, config) => {
            this.toaster.clear();
            this.newFirmware.changeListHtml = '';
            this.newFirmware.changeListHtmlUrl = data.url;
            this.toaster.pop('success', '上传成功', file.name);
        });

        file.upload.error((err) => {
            this.toaster.clear();
            this.toaster.pop('error', '上传失败', JSON.stringify(err));
        });
    }

    toggleSelection(id) {
        let idx = this.newFirmware.betaGroups.indexOf(id);

        if (idx > -1) {
            this.newFirmware.betaGroups.splice(idx, 1);
        } else {
            this.newFirmware.betaGroups.push(id);
        }
    }

    checkStr(str) {
        if (str && typeof str == 'string') {
            str = str.trim();
        }
        return str;
    }

    checkArr(arr) {
        let res = false;
        if (!arr || !arr.forEach) {
            return res;
        }
        arr.forEach(item => {
            if (item.trim().length > 0) {
                res = true;
            }
        });
        return res;
    }

    isChangeListHtmlUrl(html) {
        return typeof html === 'string' && /^https?:\/\//i.test(html);
    }

    checkData() {
        if (this.checkStr(this.newFirmware.model) && this.checkStr(this.newFirmware.brand)
            && this.newFirmware.buildNumber && this.checkStr(this.newFirmware.buildType) && this.checkStr(this.newFirmware.fingerprint)
            && this.checkStr(this.newFirmware.lang) && this.checkStr(this.newFirmware.md5)
            && this.newFirmware.size && (this.checkArr(this.newFirmware.changeList) || this.checkStr(this.newFirmware.changeListHtml) || this.checkStr(this.newFirmware.changeListHtmlUrl))) {
            return true;
        }

        this.toaster.pop({
            type: 'error',
            title: '请填写必填项',
            timeout: 3 * 1000
        });
        return false;
    }

}



// WEBPACK FOOTER //
// ./client/app/firmwares/add/add.controller.js